(() => {
  const GRID_SELECTOR = '.product-grid';
  const CARD_SELECTOR = '.product-card-wrapper';
  const SLOT_SELECTOR = '[data-card-aux-slot]';

  let rafId = null;

  const getRows = (cards) => {
    const rows = new Map();

    cards.forEach((card) => {
      const slot = card.querySelector(SLOT_SELECTOR);
      if (!slot) return;

      const top = Math.round(card.getBoundingClientRect().top);
      if (!rows.has(top)) rows.set(top, []);
      rows.get(top).push(slot);
    });

    return rows;
  };

  const equalizeInGrid = (grid) => {
    const cards = Array.from(grid.querySelectorAll(CARD_SELECTOR));
    if (!cards.length) return;

    cards.forEach((card) => {
      const slot = card.querySelector(SLOT_SELECTOR);
      if (!slot) return;
      slot.style.minHeight = '0px';
    });

    const rows = getRows(cards);

    rows.forEach((slots) => {
      let maxHeight = 0;

      slots.forEach((slot) => {
        const slotHeight = slot.scrollHeight;
        if (slotHeight > maxHeight) maxHeight = slotHeight;
      });

      slots.forEach((slot) => {
        slot.style.minHeight = `${maxHeight}px`;
      });
    });
  };

  const equalizeAll = () => {
    const grids = document.querySelectorAll(GRID_SELECTOR);
    grids.forEach(equalizeInGrid);
  };

  const scheduleEqualize = () => {
    if (rafId) return;

    rafId = window.requestAnimationFrame(() => {
      rafId = null;
      equalizeAll();
    });
  };

  const bind = () => {
    scheduleEqualize();

    window.addEventListener('resize', scheduleEqualize);
    document.addEventListener('shopify:section:load', scheduleEqualize);
    document.addEventListener('shopify:section:reorder', scheduleEqualize);

    const observer = new MutationObserver(scheduleEqualize);
    observer.observe(document.body, { childList: true, subtree: true });

    window.setTimeout(scheduleEqualize, 400);
    window.setTimeout(scheduleEqualize, 1200);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
